module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av192-91e71a8ef36bdf61a1f3817fd52000d0.jpg";